import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, ControlContainer, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { FloatLabelModule } from 'primeng/floatlabel';
import { PasswordModule } from 'primeng/password';

@Component({
  selector: 'app-password',
  standalone: true,
  imports: [CommonModule, PasswordModule, DividerModule, ReactiveFormsModule, FloatLabelModule],
  templateUrl: './password.component.html',
  styleUrl: './password.component.scss'
})
export class PasswordComponent {
  typesErrors = input.required<any>();
  label = input('Password');
  labelStyleClass = input();
  isRequired = input(true);
  isPasswordInvalidDueToLowercase = signal(true);
  isPasswordInvalidDueToUppercase = signal(true);
  isPasswordInvalidDueToNumeric = signal(true);
  isPasswordInvalidDueToSpecialChar = signal(true);
  isPasswordInvalidDueToMinLength = signal(true);
  formGroup!: FormGroup;
  password = signal({} as AbstractControl);
  
  private _controlContainer = inject(ControlContainer);
  private _destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.password.set(this.formGroup.controls['password']);
    this.subscribeToPasswordStatusChanges();
  }

  subscribeToPasswordStatusChanges() {
    const passwordControl = this.password();
    passwordControl.statusChanges.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      const isInvalid = passwordControl.invalid;
      const isTouchedOrDirty = passwordControl.touched || passwordControl.dirty;
      const isTouchedOrDirtyAndInvalid = isInvalid && isTouchedOrDirty;
      const errors = passwordControl.errors;

      this.isPasswordInvalidDueToLowercase.set(!!(isTouchedOrDirtyAndInvalid && errors?.['lowercase']));
      this.isPasswordInvalidDueToUppercase.set(!!(isTouchedOrDirtyAndInvalid && errors?.['uppercase']));
      this.isPasswordInvalidDueToNumeric.set(!!(isTouchedOrDirtyAndInvalid && errors?.['numeric']));
      this.isPasswordInvalidDueToSpecialChar.set(!!(isTouchedOrDirtyAndInvalid && errors?.['specialChar']));
      this.isPasswordInvalidDueToMinLength.set(!!(isTouchedOrDirtyAndInvalid && errors?.['length']));
    });
  }
}
